import confetti from "canvas-confetti";

export function fireDonationConfetti() {
  const colors = ["#d97706", "#f59e0b", "#fbbf24"];
  confetti({ particleCount: 120, spread: 70, origin: { y: 0.6 }, colors });
  confetti({ particleCount: 60, angle: 60, spread: 60, origin: { x: 0, y: 0.7 }, colors });
  confetti({ particleCount: 60, angle: 120, spread: 60, origin: { x: 1, y: 0.7 }, colors });
}
